export default "__VITE_ASSET__8148971e__"